
import { createContext, useContext, ReactNode } from 'react';
import { useReferralTrackingEnhanced } from '@/hooks/use-referral-tracking-enhanced';

interface ReferralTrackingContextType {
  trackClick: any;
  getReferralCode: () => string | null;
  clearReferralCode: () => void;
  setReferralCode: (code: string) => void;
  isTracking: boolean;
}

const ReferralTrackingContext = createContext<ReferralTrackingContextType | undefined>(undefined);

export const useReferralTracking = () => {
  const context = useContext(ReferralTrackingContext);
  if (!context) {
    throw new Error('useReferralTracking must be used within ReferralTrackingProvider');
  }
  return context;
};

interface ReferralTrackingProviderProps {
  children: ReactNode;
}

export const ReferralTrackingProvider = ({ children }: ReferralTrackingProviderProps) => {
  const referralTracking = useReferralTrackingEnhanced();

  return (
    <ReferralTrackingContext.Provider value={referralTracking}>
      {children}
    </ReferralTrackingContext.Provider>
  );
};
